<a
  *ngFor="let language of getAvailableLanguages()"
  [class.selectedLanguage]="getAppLanguage() === language"
  style="margin-right: 10px"
  class="cursor_pointer language"
  (click)="changeLanguage(language)"
  >{{ getEmojiFromLanguage(language) }}</a
>
